import { useMemo } from "react"

import { useLocalTable } from "shared/lib/useLocalTable"
import { TreeNode } from "shared/types/TreeNode"
import { WithID } from "shared/types/WithID"

import { getFlattenedTree } from "../utils/getFlattenedTree"

interface UseTreeStateProps<T> {
  tree: TreeNode<T>[]
  draggedElementID: string | null
  collapsedNodes: string[]
}

export function useTreeState<T extends WithID>({
  tree,
  draggedElementID,
  collapsedNodes
}: UseTreeStateProps<T>) {
  const { items, onItemPositionChange } = useLocalTable({ items: tree })

  const flattenedTree = useMemo(
    () =>
      getFlattenedTree(
        items,
        draggedElementID
          ? [...collapsedNodes, draggedElementID]
          : collapsedNodes
      ),
    [items, collapsedNodes, draggedElementID]
  )

  return {
    tree: items,
    flattenedTree,
    onItemPositionChange
  }
}
